import SvgIcon from '@mui/material/SvgIcon';

// ----------------------------------------------------------------------

export function AvatarShape({ sx, ...other }) {
  return (
    <SvgIcon
      fill="none"
      viewBox="0 0 144 62"
      xmlns="http://w3.org/2000/svg"
      sx={[
        {
          width: 144,
          height: 62,
          color: 'background.paper',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <path
        d="M111.3 23.9C100.7 13.4 92.8 0 72.6 0h-1.2C51.2 0 43.3 13.4 32.7 23.9 24.9 33.5 13.2 35.6 0 36v26h144V36c-13.2-.4-25-2.5-32.7-12.1"
        fill="currentColor"
        fillRule="evenodd"
      />
    </SvgIcon>
  );
}
